import Sortable from "sortablejs";

export function snapshotBranchConfig(args) {
  const { branches, shadowing, accountId } = args;

  return {
    branches,
    shadowing: shadowing,
    editingBranchId: null,
    editingBranchName: "",
    deletingBranchId: null,
    isPerformingDelete: false,
    reassigningToBranchId: null,
    showNewBranchForm: false,
    newBranchName: "",

    startEdit(branch) {
      this.editingBranchId = branch.id;
      this.editingBranchName = branch.name;
    },

    cancelEdit() {
      this.editingBranchId = null;
      this.editingBranchName = "";
    },

    startDelete(branch) {
      this.deletingBranchId = branch.id;
    },

    cancelDelete() {
      this.deletingBranchId = null;
      this.reassigningToBranchId = null;
      this.isPerformingDelete = false;
    },

    isEditingBranch(branch) {
      return this.editingBranchId === branch.id;
    },

    isDeletingBranch(branch) {
      return this.deletingBranchId === branch.id;
    },

    isEditingOrDeletingBranch(branch) {
      return this.isEditingBranch(branch) || this.isDeletingBranch(branch);
    },

    findBranchById(id) {
      return this.branches.find((branch) => branch.id === parseInt(id));
    },

    confirmDeleteBranch() {
      // return if no branch is selected - maybe need to handle this in the UI
      if (this.reassigningToBranchId === "") {
        return;
      }

      const deletingBranch = this.findBranchById(this.deletingBranchId);
      const reassigningToBranch = this.findBranchById(
        this.reassigningToBranchId,
      );

      if (
        window.confirm(
          `Are you sure you want to delete the branch '${deletingBranch.name}' and reassign users to '${reassigningToBranch.name}'?`,
        )
      ) {
        this.deleteBranch();
      }
    },

    deleteBranch() {
      this.isPerformingDelete = true;
      const deletingBranch = this.findBranchById(this.deletingBranchId);
      const url = `/snapshot_settings/branches/${deletingBranch.id}?reassign_to_snapshot_branch_id=${this.reassigningToBranchId}&account_id=${accountId}`;
      fetch(url, {
        method: "DELETE",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          window.pushNotification({
            title: "Success!",
            desc: `'${deletingBranch.name}' branch was deleted.`,
          });
          this.branches = this.branches.filter(
            (branch) => branch.id !== deletingBranch.id,
          );
          this.cancelDelete();
        })
        .catch(() => {
          window.pushNotification({
            title: "Error",
            desc: "There was a problem deleting the branch. Please try again.",
            success: false,
          });
          this.isPerformingDelete = false;
        });
    },

    saveBranchName(branch) {
      fetch(`/snapshot_settings/branches/${branch.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          account_id: accountId,
          name: this.editingBranchName,
        }),
      }).then(() => {
        branch.name = this.editingBranchName;
        this.editingBranchId = null;
        window.pushNotification({
          title: "Success!",
          desc: "Branch name updated.",
        });
      });
    },

    createBranch() {
      fetch("/snapshot_settings/branches", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          account_id: accountId,
          name: this.newBranchName,
        }),
      }).then(() => {
        window.location.reload();
      });
    },

    updateOrder() {
      const order = Array.from(this.$refs.branchList.children).map((el) => {
        return parseInt(el.getAttribute("data-branch-id"));
      });

      fetch("/snapshot_settings/branches/reorder", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          account_id: accountId,
          order,
        }),
      }).then(() => {
        window.pushNotification({
          title: "Success!",
          desc: "Branch order updated.",
        });
      });
    },

    init() {
      new Sortable(this.$refs.branchList, {
        animation: 150,
        handle: ".drag-handle",
        onEnd: () => this.updateOrder(),
      });
    },
  };
}
